import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';
// import '.../userStyle.scss';

import { Col, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import SalesForceCheckbox from './salesForceCheckbox';
import { CloseOutlined, CloseCircleOutlined } from '@ant-design/icons';
import TextComponent from '@sharedComponent/typography/TextComponent';
import Input from '../../../text-field/index';
import { images } from 'src/assets/img/index.js';
let regEmail =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const DeliveryAdditionalContacts = (props) => {
	const [hrName, setHrName] = useState('');
	const [hrMobile, setHrMobile] = useState('');
	const [hrLandline, setHrLandline] = useState('');
	const [hrEmail, setHrEmail] = useState('');
	const [allow, setAllow] = useState(false);
	const [errorMsgList, setErrorMsgList] = useState({
		subHrNameerr: '',
		subHrMobileerr: '',
		subHrLandlineer: '',
		subHrEmailerr: '',
	});

	const onFinish = () => {
		if (hrName && hrMobile && hrEmail && allow) {
			// props?.navigateDisabled(false);
		} else {
			// props?.navigateDisabled(true);
		}
	};

	useEffect(() => {
		console.log('PRPS ::', props);
		setHrName(props.hrName);
		setHrMobile(props.hrMobile);
		setHrLandline(props.hrLandline);
		setHrEmail(props.hrEmail);
	}, [props.hrName, props.hrMobile, props.hrLandline, props.hrEmail]);

	const validateMessages = (changeValue, allValue) => {
		if (allValue.subHrNumber && allValue.subHrNumber.replace(/[^0-9]/g, '').length !== 8) {
			setAllow(false);
		} else if (allValue.subHrLandline && allValue.subHrLandline.replace(/[^0-9]/g, '').length !== 8) {
			setAllow(false);
		} else if (allValue.subHrEmail && !regEmail.test(allValue.subHrEmail)) {
			setAllow(false);
		} else {
			setAllow(true);
		}
	};

	const validateForm = (e) => {
		if (e.target.name == 'subhrNumber') {
			if (hrMobile.length > 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrMobileerr: 'Mobile Number must be within 8 digits' };
				});
			} else if (hrMobile.length < 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrMobileerr: 'Mobile Number must be not less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrMobileerr: '' };
				});
			}
		}

		if (e.target.name == 'subHrLandline') {
			if (hrLandline.length > 8 && hrLandline.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrLandlineer: 'Landline Number must be within 8 digits' };
				});
			} else if (hrLandline.length < 8 && hrLandline.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrLandlineer: 'Landline Number must be not less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrLandlineer: '' };
				});
			}
		}

		if (e.target.name == 'subHrEmail') {
			if (!regEmail.test(hrEmail)) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrEmailerr: 'Email is not Valid' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrEmailerr: '' };
				});
			}
		}
	};

	return (
		<>
			<div className="delivery_card_contact_form" key={props.index}>
				{props.length !== 1 && (
					<div className="close-container">
						{' '}
						<div
							onClick={() => props.removeContact(props.index)}
							style={{ cursor: 'pointer', paddingBottom: '15px', width: '100%', textAlign: 'right' }}>
							{' '}
							X
						</div>
					</div>
				)}
				<Form onFinish={onFinish()} onValuesChange={validateMessages}>
					<Form.Item name="subHrName">
						<div className="global_input_Container">
							<Input
								type="text"
								labels={
									<span>
										Name <text style={{ color: 'red' }}>*</text>
									</span>
								}
								onBlur={validateForm}
								value={hrName}
								// onChange={(e) => setHrName(e.target.value.replace(/[^A-Za-z]/gi, ''))}
								onChange={(e) => props.handleValueChange(props.index, 'hrName', e.target.value.replace(/[^A-Za-z]/gi, ''))}
							/>
						</div>
						<div>
							<TextComponent className="errorText">{errorMsgList.subHrNameerr}</TextComponent>
						</div>
					</Form.Item>
					<Form.Item name="subHrNumber">
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
								<div className="country_container">
									<img className="countryFlag" src={images.UAE} />
									<div className="countrycode" style={{ width: 'max-content', paddingRight: 20 }}>
										<TextComponent className="contact_no_text">+971 5</TextComponent>
									</div>
								</div>
								<div className="contact_container" style={{ width: '-webkit-fill-available' }}>
									<div className="global_input_Container">
										<Input
											name="subhrNumber"
											maxLength={8}
											type="text"
											onBlur={validateForm}
											labels={
												<span>
													Mobile Number <text style={{ color: 'red' }}>*</text>
												</span>
											}
											style={{ width: '300px !important' }}
											value={hrMobile}
											// onChange={(e) => setHrMobile(e.target.value.replace(/[^0-9]/g, ''))}
											onChange={(e) => props.handleValueChange(props.index, 'hrMobile', e.target.value.replace(/[^0-9]/g, ''))}
										/>
									</div>
								</div>
							</div>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrMobileerr}</TextComponent>
							</div>
						</div>
					</Form.Item>
					<Form.Item name="subHrLandline">
						<div className="global_input_Container">
							<Input
								maxLength={8}
								name="subHrLandline"
								type="text"
								onBlur={validateForm}
								labels={<span>Landline</span>}
								value={hrLandline}
								// onChange={(e) => setHrLandline(e.target.value.replace(/[^0-9]/g, ''))}
								onChange={(e) => props.handleValueChange(props.index, 'hrLandline', e.target.value.replace(/[^0-9]/g, ''))}
							/>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrLandlineer}</TextComponent>
							</div>
						</div>
					</Form.Item>
					<Form.Item name="subHrEmail">
						<div className="global_input_Container">
							<Input
								maxLength={100}
								name="subHrEmail"
								type="text"
								onBlur={validateForm}
								labels={
									<span>
										Email ID <text style={{ color: 'red' }}>*</text>
									</span>
								}
								value={hrEmail}
								// onChange={(e) => setHrEmail(e.target.value)}
								onChange={(e) => props.handleValueChange(props.index, 'hrEmail', e.target.value)}
							/>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrEmailerr}</TextComponent>
							</div>
						</div>
					</Form.Item>
				</Form>
			</div>
		</>
	);
};
export default DeliveryAdditionalContacts;
